// Per-tab cache of the verified package token (backend#form-verify). Once the
// patient confirms the pinned chart's DOB, the token that unlocks the forms (and
// stage/submit/draft) is kept here so a refresh WITHIN the tab resumes without
// re-prompting for DOB. Tab-scoped sessionStorage, cleared on submit alongside
// v2Session. The token is a bearer credential (not answers/PHI) and never leaves
// the device; a fresh tab or new device has no entry and must re-verify.

const PREFIX = 'operaitor_fpv2_tok:';

function storageKey(packageInstanceId: string): string {
  return `${PREFIX}${packageInstanceId}`;
}

export function readVerifiedToken(packageInstanceId: string): string | null {
  try {
    const raw = window.sessionStorage.getItem(storageKey(packageInstanceId));
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

export function writeVerifiedToken(packageInstanceId: string, token: string): void {
  try {
    window.sessionStorage.setItem(storageKey(packageInstanceId), token);
  } catch { /* storage unavailable: in-memory only for this tab */ }
}

export function clearVerifiedToken(packageInstanceId: string): void {
  try {
    window.sessionStorage.removeItem(storageKey(packageInstanceId));
  } catch { /* nothing to clear */ }
}
